import UpdatePassword from './UpdatePassword'

export default UpdatePassword
